import { useEffect, useState } from "react";
import { cachedGet } from "@/lib/publicApi";
import { Skeleton } from "./SaudeLayout";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Emergency() {
  const [settings, setSettings] = useState(null);
  const [pending, setPending] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await cachedGet("/settings");
        setSettings(data);
      } catch {
        setSettings({});
      }
    })();
  }, []);

  if (!settings) return <Skeleton lines={3} testId="emergency-skeleton" />;

  const emergency = settings.emergency || {};
  const contacts = emergency.contacts || [];

  return (
    <div data-testid="saude-emergency-page" className="space-y-6">
      <div>
        <p className="er-label text-danger">Preciso de ajuda agora</p>
        <h1 className="mt-3 font-display text-2xl font-medium tracking-tight text-ink-900">Canais de emergência</h1>
      </div>

      <p data-testid="emergency-message" className="rounded-2xl border border-danger/30 bg-danger/8 p-5 text-sm leading-relaxed text-ink-700">
        {emergency.message}
      </p>

      <div className="space-y-3">
        {contacts.map((contact) => (
          <div key={contact.number} className="er-card" data-testid={`emergency-contact-${contact.number}`}>
            <p className="font-display text-base font-medium text-ink-900">{contact.label}</p>
            <p className="mt-1 text-sm text-ink-500">Telefone {contact.number}</p>
            <Button
              data-testid={`emergency-call-${contact.number}`}
              onClick={() => setPending(contact)}
              className="mt-4 h-12 w-full rounded-full bg-danger text-white hover:bg-danger/90"
            >
              <Phone size={16} className="mr-2" /> Ligar para {contact.number}
            </Button>
          </div>
        ))}
      </div>

      {pending ? (
        <div data-testid="emergency-confirm-dialog" role="dialog" aria-modal="true" className="er-card border-danger/40">
          <p className="font-display text-base font-medium text-ink-900">Confirmar ligação</p>
          <p className="mt-2 text-sm text-ink-600">
            Deseja abrir o discador para {pending.label} ({pending.number})?
          </p>
          <div className="mt-5 flex gap-3">
            <Button
              data-testid="emergency-confirm-call"
              onClick={() => {
                window.location.href = `tel:${pending.number}`;
                setPending(null);
              }}
              className="h-12 flex-1 rounded-full bg-danger text-white hover:bg-danger/90"
            >
              Ligar agora
            </Button>
            <Button
              variant="outline"
              data-testid="emergency-cancel-call"
              onClick={() => setPending(null)}
              className="h-12 flex-1 rounded-full"
            >
              Cancelar
            </Button>
          </div>
        </div>
      ) : null}

      <p className="text-xs leading-relaxed text-ink-400">
        {emergency.pending_validation} Este aplicativo não faz triagem automatizada e não substitui atendimento médico
        de emergência.
      </p>
    </div>
  );
}
